import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const SingleDatePicker = ({
    selectedDate,
    label,
    handleChangeDate,
    iconClass,
    icon,
    labelClass
}) => {
    const today = new Date();

    return (
        <>
            <div className="single-date-picker-contanier">
                {label && <span className={`${labelClass}`}>{label}</span>}
                <DatePicker
                    selected={selectedDate}
                    onChange={handleChangeDate}
                    maxDate={today} // Restrict to past dates only
                    placeholderText="Select Date"
                    isClearable
                />
                {!selectedDate && <i className={`${icon} calendar-icon`}></i>}
            </div>
        </>
    );
};

export default SingleDatePicker;
